export enum SortOrderType {
    ASC,
    DESC
}
